
  export default {
    name: 'AccountNavigation',
    data: () => ({
      menuItems: [
        {
          icon: 'fal fa-cog',
          title: 'Meine Einstellungen',
          route: {
            name: 'mySettings',
          },
        },
        {
          icon: 'fal fa-trash-alt',
          title: 'Account löschen',
          route: {
            name: 'myAccountDeletion',
          },
        },
      ],
    }),
    created() {
      if (this.$auth.user.hasPassword) {
        this.menuItems.splice(
          1,
          0,
          {
            icon: 'fal fa-envelope',
            title: 'E-Mail ändern',
            route: {
              name: 'myEmailChange',
            },
          },
          {
            icon: 'fal fa-lock',
            title: 'Passwort ändern',
            route: {
              name: 'myPasswordChange',
            },
          }
        );
      }
    },
  };
